import {
  RocketOutlined,
  RobotOutlined,
  TeamOutlined,
  BarChartOutlined,
  CheckCircleOutlined,
  LinkOutlined,
  DatabaseOutlined,
} from '@ant-design/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../common.module.less';

interface FeatureProps {
  className?: string;
}

const FeatureList: React.FC<FeatureProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.features} ${className}`}>
      <div className={styles.featureRow}>
        <div className={styles.featureItem}>
          <RocketOutlined className={styles.featureIcon} />
          <div className={styles.featureText}>
            <h3>{t('pages.layouts.userLayout.feature.quickStart')}</h3>
          </div>
        </div>
        <div className={styles.featureItem}>
          <RobotOutlined className={styles.featureIcon} />
          <div className={styles.featureText}>
            <h3>{t('pages.layouts.userLayout.feature.aiAssist')}</h3>
          </div>
        </div>
        <div className={styles.featureItem}>
          <TeamOutlined className={styles.featureIcon} />
          <div className={styles.featureText}>
            <h3>{t('pages.layouts.userLayout.feature.teamWork')}</h3>
          </div>
        </div>
        <div className={styles.featureItem}>
          <BarChartOutlined className={styles.featureIcon} />
          <div className={styles.featureText}>
            <h3>{t('pages.layouts.userLayout.feature.projectControl')}</h3>
          </div>
        </div>
      </div>

      <div className={styles.featureRow}>
        <div className={styles.featureItem}>
          <CheckCircleOutlined className={styles.featureIcon} />
          <div className={styles.featureText}>
            <h3>{t('pages.layouts.userLayout.feature.auditDisplay')}</h3>
          </div>
        </div>
        <div className={styles.featureItem}>
          <LinkOutlined className={styles.featureIcon} />
          <div className={styles.featureText}>
            <h3>{t('pages.layouts.userLayout.feature.traceability')}</h3>
          </div>
        </div>
        <div className={styles.featureItem}>
          <DatabaseOutlined className={styles.featureIcon} />
          <div className={styles.featureText}>
            <h3>{t('pages.layouts.userLayout.feature.dataAssets')}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureList;
